import React, {Component} from 'react';
import {Trans} from '@lingui/macro';
import {connect} from 'react-redux';
import { IconFont } from '../IconFont';
import BukkuTooltip from '../Tooltip';

class TransactionTransferStatus extends Component {
    mappingTitle = {
        TRANSFERRED: <Trans>Fully transferred</Trans>,
        PARTIAL_TRANSFERRED: <Trans>Partially transferred</Trans>,
        NOT_TRANSFERRED: <Trans>Not transferred</Trans>,
    };

    renderIcon = () => {
        const { record } = this.props;
        switch (record.transfer_status) {
            case 'TRANSFERRED':
                return <IconFont type="icon-transferred" />;
            case 'PARTIAL_TRANSFERRED':
                return <IconFont type="icon-partially-transferred" />;
            case 'NOT_TRANSFERRED':
                return <IconFont type="icon-not-transferred" />;
            default:
                return null;
        }
    };

    render() {
        const { record } = this.props;
        const title = this.mappingTitle[record.transfer_status];

        return (
            <BukkuTooltip title={title}>
                <span style={{ fontSize: 20 }}>{this.renderIcon()}</span>
            </BukkuTooltip>
        );
    }
}
export default connect(() => ({
    //
}), {
    //
})(TransactionTransferStatus);
